/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvoiceMilestoneFromJSON, InvoiceMilestoneToJSON, } from './InvoiceMilestone';
import { TipologiaBloccoFromJSON, TipologiaBloccoToJSON, } from './TipologiaBlocco';
/**
 * Check if a given object implements the StatoAvanzamentoLavoriOutputDto interface.
 */
export function instanceOfStatoAvanzamentoLavoriOutputDto(value) {
    return true;
}
export function StatoAvanzamentoLavoriOutputDtoFromJSON(json) {
    return StatoAvanzamentoLavoriOutputDtoFromJSONTyped(json, false);
}
export function StatoAvanzamentoLavoriOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'invoiceMilestone': json['invoiceMilestone'] == null ? undefined : InvoiceMilestoneFromJSON(json['invoiceMilestone']),
        'isInviato': json['isInviato'] == null ? undefined : json['isInviato'],
        'dataDiInvio': json['dataDiInvio'] == null ? undefined : (new Date(json['dataDiInvio'])),
        'idTipologiaBlocco': json['idTipologiaBlocco'] == null ? undefined : TipologiaBloccoFromJSON(json['idTipologiaBlocco']),
        'importo': json['importo'] == null ? undefined : json['importo'],
    };
}
export function StatoAvanzamentoLavoriOutputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'invoiceMilestone': InvoiceMilestoneToJSON(value['invoiceMilestone']),
        'isInviato': value['isInviato'],
        'dataDiInvio': value['dataDiInvio'] == null ? undefined : ((value['dataDiInvio']).toISOString()),
        'idTipologiaBlocco': TipologiaBloccoToJSON(value['idTipologiaBlocco']),
        'importo': value['importo'],
    };
}
